import { useMemo } from 'react'

import { generateId } from 'core-components/helpers/generateId'
import { Flex } from 'core-components/library/flex'
import { IWidget } from 'core-components/sitebuilder/models/IWidget'

interface IUseIsValid {
  widget: IWidget
}

export const useIsValid = ({ widget }: IUseIsValid) => {
  const errorMessage = useMemo(() => {
    const errors: string[] = []
    if (widget.type !== 'FromLibrary') {
      if (!widget.i) {
        errors.push('Empty id')
      }
      if (!widget.title) {
        errors.push('Empty title')
      }
      if (!widget.group) {
        errors.push('Empty group name')
      }
    } else {
      if (!widget.i) {
        widget.i = generateId('library-widget')
      }
    }

    if (!widget.type) {
      errors.push('Empty type')
    }

    if (!errors.length) {
      return null
    }

    return (
      <Flex flexDirection={'column'}>
        <b>Errors: </b>
        <ul style={{ marginBottom: 0 }}>
          {errors.map((el) => {
            return <li key={el}>{el}</li>
          })}
        </ul>
      </Flex>
    )
  }, [widget])

  return { errorMessage }
}
